import { colors } from 'ui/theme/colors';
import { AnimationContainer, LoadingCircle } from './Spinner.styled';

type Props = {
  size?: number | string;
  color?: string;
  isColorInherited?: boolean;
};

export const CircleSpinner = ({
  size = 36,
  color = colors.grey15,
  isColorInherited = false,
  ...props
}: Props) => (
  <AnimationContainer data-test="loading-circle-wrapper" {...props}>
    <LoadingCircle
      aria-label="Loading"
      data-test="loading-circle"
      height={size}
      width={size}
      color={color}
      isColorInherited={isColorInherited}
    />
  </AnimationContainer>
);
